// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='DataTimelineDialog'] > header button {\n      display: none;\n    }\n  [name='DataTimelineDialog'] button.plain {\n    color: var(--primary-style-color);\n    font-weight: 600;\n  }\n  [name='DataTimelineDialog'] .content > .form {\n    margin-bottom: 40px;\n  }\n  [name='DataTimelineDialog'] input[type='text'] {\n    font-size: 14px;\n    height: inherit;\n  }\n", ""]);
// Exports
module.exports = exports;
